import styled from '@emotion/styled';
import { colors } from '../theme/colors';

/**
 * PanelButton - Standard button component for ActionMenu panel sections
 * Consistent styling across all panel buttons (Case Management, Fields, etc.)
 * 
 * @param {boolean} deleteMode - If true, hover state uses error color theme
 */
const PanelButton = styled.button`
  width: 100%;
  padding: 0.75rem 1rem;
  background: #4a4a4a;
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 6px;
  color: #e0e0e0;
  font-size: 0.75rem;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  
  &:hover {
    background: ${props => props.deleteMode ? colors.error : '#4b5563'};
    border-color: ${props => props.deleteMode ? colors.error : 'rgba(255, 255, 255, 0.2)'};
  }
  
  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
`;

export default PanelButton;
